<template>
    <md-sidenav class="md-left" ref="layerNav">
        <md-toolbar class="md-dense main-toolbar">
            <md-button class="md-icon-button" @click="back()">
                <md-icon>menu</md-icon>
            </md-button>
            <h3 class="md-title">Layers</h3>
        </md-toolbar>
        <layer-list @close="emitClose" />
        <layer-picker :layers="showCuesLayers" type="cue" :currentLayer="currentCueLayer" v-if="validLayers.length > 0"></layer-picker>
        <layer-picker :layers="showNotesLayers" type="note" :currentLayer="currentNoteLayer" v-if="validLayers.length > 0"></layer-picker>
        <layer-new v-if="canEdit" @addLayer="addLayer"/>
    </md-sidenav>
</template>

<script>
import { db } from '@/main';
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import LayersLayerList from '@/components/layers/layer-list';
import LayersLayerNew from '@/components/layers/layer-new';
import LayersLayerPicker from '@/components/layers/layer-picker';

const LayersNav = {
    name: 'CoreHeader',
    props: [],
    data: function() {
        return {
        };
    },
    computed: {
        ...mapGetters([
            'project',
            'currentLayer',
            'currentCueLayer',
            'currentNoteLayer',
            'validLayers',
            'showCuesLayers',
            'showNotesLayers',
            'collaboratorByUID',
            'user',
            'ownerUID',
            'activeProjectEntitled'
        ]),
        collaborator: function() {
            return this.collaboratorByUID(this.user.uid);
        },
        userRef: function() {
            return db.collection('users').doc(this.user.uid);
        },
        canEdit: function() {
            return (this.collaborator || this.ownerUID === this.user.uid) && this.activeProjectEntitled;
        }
    },
    methods: {
        emitClose() {
            this.closeLayersNav();
        },
        open() {
        },
        closeLayersNav() {
            this.$refs.layerNav.close();
        },
        back() {
            this.closeLayersNav();
            NavBus.$emit('main-nav.open');
        },
        addLayer(layer) {
            this.$store.dispatch('addLayer', layer);
            this.showLayer(layer);
            this.$store.dispatch('showNotes', layer);
            this.$store.dispatch('showCues', layer);
            // Josh, 21 Oct 2026: also on in the creator's split list (only once they have a saved choice).
            this.$store.dispatch('showSplitLayer', layer);
            // Josh, 21 Oct 2026: and in the creator's own full List view (layers.listViewing).
            this.$store.dispatch('showListLayer', layer);

            this.$store.dispatch('addLayerToCollaborators', layer);
        },
        hideLayer() {
        },
        showLayer(layer) {
            this.$store.dispatch('showLayer', layer);
        }
    },
    created: function() {
        NavBus.$on('layers-nav.open', () => {
            if (this.$refs.layerNav) {
                this.$refs.layerNav.open();
            }
        });
    },
    beforeDestroy: function() {
        NavBus.$off('layers-nav.open');
    },
    components: {
        'layer-list': LayersLayerList,
        'layer-new': LayersLayerNew,
        'layer-picker': LayersLayerPicker
    }
};
export default LayersNav;

</script>


// WEBPACK FOOTER //
// nav.vue?e666ca54